<template>
    <form role="form">
        <div class="container-fluid shadow">
            <div class="row">
               
                <div class="row">
                    <div class="col-md-12">
                   
                        <div class="row">
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="col-sm-2">
                                        <span class="align-middle">{{addProductOption.codiceLbl}}</span>
                                    </div>
                                        <div class="col-sm-9">
                                            <input type="text" v-model="codiceValue" id="codiceId" @keydown.enter.prevent="cercaClick()"
                                                class="form-control form-control-sm" :placeholder="addProductOption.codicePlhd"/> 
                                        </div>
                                        <div class="col-sm-1">
                                            <button class="btn btn-primary" style="padding: 2px 5px; border-radius: 2px;" @click.prevent="emptyField('codiceId')">
                                                <i :class="$root.icons.clear" aria-hidden="true" style="margin-left: 0px;"></i>
                                            </button>
                                        </div>
                                </div>
                                <div style="height: 25px;"></div>
                                <div class="form-group">
                                    <div class="col-sm-2">
                                        <span class="form-test" style="vertical-align: middle">{{addProductOption.descrizioneLbl}}</span>
                                    </div>
                                        <div class="col-sm-9">
                                            <input type="text" v-model="descrizioneValue" id="descrizioneId" @keydown.enter.prevent="cercaClick()"
                                                class="form-control" :placeholder="addProductOption.descrizionePlhd"/> 
                                        </div>
                                    <div class="col-sm-1">
                                        <button class="btn btn-primary" style="padding: 2px 5px; border-radius: 2px;" @click.prevent="emptyField('descrizioneId')">
                                            <i :class="$root.icons.clear" aria-hidden="true" style="margin-left: 0px;"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <div class="col-sm">
                                        <span >&nbsp;</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm">
                                        <span >&nbsp;</span>
                                    </div>
                                </div>
                                <div class="form-group " >
                                    <button @click.prevent="cercaClick" class="btn btn-primary-default" :class="$root.icons.search_btn" style="width: 80px"></button>
                                </div>
                            </div>
                            
                        </div>
                        <div class="row">
                            <div class="col-md">
                                <div class="form-group">

                                    <div style="padding: 5px;">                                       

                                        <grid :others="others" :columns="addProdAttributesCfg.columns"
                                         :source.sync="addProdList" :options="options" 
                                                :lang="$root.token.idLingua" :name="addProdAttributesCfg.title"> 
                                        </grid>

                                   
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  id="searchingId" v-show="searching" class="sk-cube-grid"  style="position: absolute; top: 150px; right: 0px; left: 0px;"> 
          <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
        </div>
    </form>
</template>

<script>
import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import { eventBus } from "../../../eventbus";
//const searcher = require('products_searcher');

export default {
    mixins: [FormMixin],
    props: {
        parentList: Array, 
    },
    components: {
        Grid,
        InputW,
        DynTableWrapper,
    },
    data: function () {
        var vm = this;
        return {
            addProductOption: {
                codiceLbl: vm.$Jed.firstUpperTranslate('code'),
                codicePlhd: vm.$Jed.firstUpperTranslate('starts with...'),
                descrizioneLbl: vm.$Jed.firstUpperTranslate('description'),
                descrizionePlhd: vm.$Jed.firstUpperTranslate('contains...'),
                annullaBtnLbl: vm.$Jed.firstUpperTranslate('cancel')          
            },
            codiceValue: '',
            descrizioneValue: '',
            options: {
                    columnsresize: true,
                    columnsreorder: true,
                    rowsheight: 26,
                    theme: "light",
                    width: "100%",
                    selectionmode: "none",
                    pageable: true,
                    showfilterrow: false,
                    filterable: true,
                    sortable: true,
                    pageable: false,
                    autoheight: false,
                    height: 210,
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails:
                            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                        rowdetailsheight: 250 /* ! 230 + 20 ! */
                    },
                    /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                    ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                    initrowdetails: "nested",
                    rendered: null
            },
            others:{
                adaptColumns: true
            },
            addProdAttributesCfg: {
                    ID: "addProdAttributesId",
                    title: "AttributiTabella",
                    label_title: "",
                    visible: true,
                    columns: {
                        configs:{
                            codice: {
                                text: vm.$Jed.firstUpperTranslate('code'), //il vecchio
                                position: 1,
                                visible: true,
                                editable: false,
                                width: "15.5%",
                                searchable: false,
                                sorting: true,
                                datafield: "cod"
                            },
                            descr: {
                                text: vm.$Jed.firstUpperTranslate('description'),
                                position: 3,
                                visible: true,
                                editable: false,
                                width: "26.5%",
                                searchable: false,
                                sorting: true,
                                datafield: "descr"
                            },
                            codsost: {
                                text: vm.$Jed.firstUpperTranslate("substitute code"), //il nuovo
                                position: 2,
                                visible: true,
                                editable: false,
                                width: "15.5%",
                                searchable: false,
                                sorting: true,
                                datafield: "codsost"
                            },
                            unitmis: {
                                text: vm.$Jed.firstUpperTranslate('unit of measure'),
                                position: 4,
                                visible: true,
                                editable: false,
                                width: "15%", 
                                searchable: false,
                                sorting: true,
                                datafield: "unitmis"
                            },
                            qty: {
                                text: vm.$Jed.firstUpperTranslate('min qty'),
                                position: 5,
                                visible: true,
                                editable: false,
                                width: "12%",
                                searchable: false,
                                sorting: true,
                                datafield: "qty",
                                type: "number",
                                cellsrenderer: function (data_row, datafield, value) {
                                    if(value)return '<div style="display: table; width: 100%; height: 100%"><div style="display: table-cell; vertical-align: middle; text-align: center; "><span style="margin-right: 6px">' + Number(value).toLocaleString() + '</span></div></div>';
                                }
                            },
                            pri: {
                                text: vm.$Jed.firstUpperTranslate("price"),
                                position: 5,
                                hidden: true,
                                editable: false,
                                width: "10.5%",
                                searchable: false,
                                sorting: true,
                                datafield: "pri"
                            },
                            icon: {
                                text: "",
                                position: 6,
                                visible: true,
                                editable: false,
                                width: "5%",
                                searchable: false,
                                sorting: true,
                                iconcolumn: true,
                                geticonclass: function(data_row, index){
                                    //console.log(data_row.salable)
                                    if(!data_row.salable){
                                        return vm.$root.icons.close
                                    }else{
                                        return vm.$root.icons.cart_in 
                                    }
                                },
                                onclick: function(obj, ev, value) {
                                    if(obj.salable){
                                        vm.$emit("onAddProductEvent", obj);
                                    }
                                }
                            }
                        }
                    }
            },
            addProdList: [],
            searching: false,
            alreadyInCart: []
        }
    },
    activated: function() {
        var vm = this;
        vm.addProdList = [];
    },
    mounted: function(){
        var vm = this;
        this.$root.$on('clearAllFields', () => {
            vm.clearAll() }
        );
    },
    methods: {
        cercaClick () {
            var vm = this,
                splitSearchFlag = vm.$root.preferences.splitSearch;

            vm.addProdList = [];
            //preparo l'oggetto con tutti i criteri di ricerca valorizzati
            var filters = {
                id: this.codiceValue,						
                des: this.descrizioneValue,
                spe: "",
                not: "",
                sost: true, //flag per fare la ricerca anche sul registry (ovvero cerco anche i sostitutivi che iniziano con codice o contengono descrizione)
                mid: vm.$root.validity ? vm.$root.validity : "",
                sim: vm.$root.validity ? "Sì" : "" //se è stata selezionata la matricola nel wizard all'inizio, allora la ricerca da carrello deve guardare dentro la matricola
            },
            valid_criteria = false;

            if(vm.$root.validity){
                splitSearchFlag = false;
            }

            if((filters.des || filters.id) && this.$Behaviors.search.limitSearchForType && this.$Behaviors.search.limitSearchForType!=""){
                filters['type'] = this.$Behaviors.search.limitSearchForType
            }

            for(var c in filters){ 
                if(filters[c] != "" && filters[c].length >= 4){ //se c'è almeno un criterio valorizzato e i caratteri inseriti sono almeno 4
                    valid_criteria = true;
                    break
                }
            } 

            if(valid_criteria){
                //nascondo il messaggio "Nessun dato da mostrare"
                vm.$nextTick(function(){
                    $('#AttributiTabella').jqxGrid({ showemptyrow: false}); 
                    $("#AttributiTabella").jqxGrid('refresh');
                })
                //mostro il waiter
                vm.searching = true;
                vm.alreadyInCart = []
                try {
                    //FACCIO LA RICHIESTA AL CMD DI RICERCA 
                    var now = Date.now()
                    vm.$root.microservice({
                        "role": "search",
                        "cmd": "GetProdByCriteria",
                        "params": {
                            "criteri": filters,
                            "lang": vm.$root.token.siglaLingua,
                            "defLang": vm.$root.token.defaultLang,
                            "root": vm.$root.index_as_root,
                            "split": splitSearchFlag,
                            "caller": "cartSearch",
                            "idCliente": vm.$root.token.idCliente,
                            "tipoOrdine": vm.$root.shopCartData.tipoOrdine
                        }
                        }).then((response) => { 
                            var now2 = Date.now()
                            console.log('DURATION: ', now2 - now);
                            vm.searching = false;
                            //console.log(response);
                            if(response && response.body && response.body.errorMsg){
                                vm.filterPartialRes = []
                                vm.filtered = []
                                if(vm.type=='criteria')eventBus.$emit('no_search_results');
                                if(vm.type=='model')eventBus.$emit('no_model_results');
                                if(vm.type=='marketing')eventBus.$emit('no_mark_results');
                                if(vm.type=='merchandising')eventBus.$emit('no_merch_results');
                                eventBus.$emit('alert', {
                                    message: vm.$Jed.firstUpperTranslate("Request timed out. Try to do a more specific search.", null), 
                                    type: "warning",
                                    action: ''
                                })
                            } else if (response && response.body.length>0) {
                                //rimuovo il numero in fondo che indica quanti risultati restituire nella ricerca così itero sugli elementi giusti
                                response.body.pop()
                                if(vm.$root.validity){
                                    //se avevo selezionato la matricola all'inizio, nel risultato mi ritorna il modello quindi rimuovo l'elemento in fondo 
                                    response.body.pop() 
                                } 
                                for(var e in response.body){
                                    var elem = response.body[e] 
                                    //se il prodotto non è già in carrello ed è vendibile
                                    if( (!vm.parentList.some(p => {
                                        if(elem.newId){
                                            return p['cod'] === elem.newId
                                        }else{
                                            return p['cod'] === elem.id
                                        }
                                    }
                                    )) && elem.salable ) {
                                        vm.addProdList.push({
                                            cod: elem.spo || elem.spi ? elem.spi : elem.id ? elem.id : elem.sid, //il vecchio
                                            codsost: elem.spo || elem.spi ? elem.id : elem.newId, //il nuovo
                                            qty: elem.qty && elem.qty >= elem.mqt ? elem.qty : elem.mqt,
                                            descr: elem.spo ? elem.spo.des : elem.des,
                                            unitmis: vm.$Jed.translate(elem.uni),
                                            salable: elem.salable,
                                            refObj: elem
                                        })
                                    }else{
                                        //se il prod cercato è già in carrello 
                                        if(vm.parentList.some( p => {
                                            if(elem.newId){
                                                return p['cod'] === elem.newId
                                            }else{
                                                return p['cod'] === elem.id
                                            }
                                        })){
                                            if(response.body.length == 1){ //se è l'unico trovato dalla ricerca
                                                eventBus.$emit('alert', {
                                                    message: vm.$Jed.firstUpperTranslate("Product already in cart. To add other pieces use quantity column.", null), 
                                                    type: "warning",
                                                    action: ''
                                                })
                                            }
                                        }
                                        /* if(!elem.salable){
                                            eventBus.$emit('alert', {
                                                message: vm.$Jed.firstUpperTranslate("Product is not salable.", null), 
                                                type: "warning",
                                                action: ''
                                            })
                                        } */
                                    }
                                }
                                console.log(vm.addProdList)
                            }else{
                                console.log("no results from catalog")
                            }
                            if(!vm.addProdList.length>0){
                                /* //se nel risultato della ricerca non ci sono prodotti vendibili ri-mostro il messaggio 
                                var localizationobject = { emptydatastring: "Nessun dato da mostrare" };
                                $("#AttributiTabella").jqxGrid('localizestrings', localizationobject);
                                $('#AttributiTabella').jqxGrid({ showemptyrow: true});  */
                                $("#AttributiTabella").jqxGrid('refresh');
                            }
                        }, err=>{
                            eventBus.$emit('no_search_results');
                            console.log(err)
                            //vedi gestione errore in main.js > microservice
                        })
                        .catch(err => {
                            /* //se nel risultato della ricerca non ci sono prodotti vendibili ri-mostro il messaggio 
                            var localizationobject = { emptydatastring: "Nessun dato da mostrare" };
                            $("#AttributiTabella").jqxGrid('localizestrings', localizationobject); 
                            $('#AttributiTabella').jqxGrid({ showemptyrow: true}); */
                            $("#AttributiTabella").jqxGrid('refresh');
                            console.log(err);
                            var msg = ''
                            if(err)msg = err.body && err.body.error ? err.body.error : err.message ? err.message : ''
                            eventBus.$emit('no_search_results');
                            eventBus.$emit('alert', {
                                message: "Application caught an error <br> <h5>Details: " + "search.GetProdByCriteria - " + msg +'</h5>',
                                type: "error",
                                action: ''
                            })
                            vm.searching = false;
                        })
                }catch(err){
                    console.log("Errore nella ricerca dei prodotti", err);
                }
            }else{
                eventBus.$emit('openSearchCriteriaModal', vm.$Jed.firstUpperTranslate('insert at least one search criterion. Must be at least 4 characters long'));
            }
        },
        clearAll() {
            var vm = this;
            vm.addProdList = [];
            vm.codiceValue = '';
            vm.descrizioneValue = '';
        },
        cancelClick() {
            this.clearAll();
            this.$emit("onCancelAddProductEvent");
        },
        changeCodeEvent() {
            this.descrizioneValue="";
        },
        changeDescrEvent(){
            this.codiceValue="";
        },
        emptyField: function(field){
            if(field=='codiceId'){
                this.codiceValue = "";
            }else if(field == 'descrizioneId'){
                this.descrizioneValue="";
            }
        }
    }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/AddProduct.vue?e8b1221e